import React from 'react';
import PropTypes from 'prop-types';
import { INBOX_MSG_TYPE } from '../../../../../services/utilityFunctions';
import InboxMessageProp from '../../../propTypes/inboxMessageProp';
import InfoMessage from './components/messageTypes/InfoMessage';
import NewsMessage from './components/messageTypes/NewsMessage';
import MagazineMessage from './components/messageTypes/MagazineMessage';
import VideoMessage from './components/messageTypes/VideoMessage';
import PodcastMessage from './components/messageTypes/PodcastMessage';
import PDFMessage from './components/messageTypes/PDFMessage';
import ProfilingMessage from './components/messageTypes/ProfilingMessage';
import SurveyMessage from './components/messageTypes/SurveyMessage';
import DriveMessage from './components/messageTypes/DriveMessage';

export default function InboxMessage({ message, onSeeMore }) {
  switch (message.type) {
    case INBOX_MSG_TYPE.NEWS:
      return <NewsMessage message={message} onClick={onSeeMore} />;
    case INBOX_MSG_TYPE.MAGAZINE:
      return <MagazineMessage message={message} onClick={onSeeMore} />;
    case INBOX_MSG_TYPE.VIDEO:
      return <VideoMessage message={message} onClick={onSeeMore} />;
    case INBOX_MSG_TYPE.PODCAST:
      return <PodcastMessage message={message} onClick={onSeeMore} />;
    case INBOX_MSG_TYPE.PDF:
      return <PDFMessage message={message} onClick={onSeeMore} />;
    case INBOX_MSG_TYPE.PROFILING:
      return <ProfilingMessage message={message} />;
    case INBOX_MSG_TYPE.SURVEY:
    case INBOX_MSG_TYPE.HIGHLIGHT_SURVEY_QUESTION:
    case INBOX_MSG_TYPE.EVENT:
      return <SurveyMessage message={message} />;
    case INBOX_MSG_TYPE.DRIVE:
      return <DriveMessage message={message} onClick={onSeeMore} />;
    case INBOX_MSG_TYPE.INFO:
    case INBOX_MSG_TYPE.CUSTOM:
    default:
      return <InfoMessage message={message} onClick={onSeeMore} />;
  }
}

InboxMessage.propTypes = {
  message: PropTypes.shape(InboxMessageProp.propType).isRequired,
  onSeeMore: PropTypes.func.isRequired,
};
